/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Works_2Inputs */

const en_vc_status_works_2 = /** @type {(inputs: Vc_Status_Works_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint, gradients, appearance and transparency`)
};

const zh_vc_status_works_2 = /** @type {(inputs: Vc_Status_Works_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上色、渐变、外观和透明度`)
};

/**
* | output |
* | --- |
* | "Paint, gradients, appearance and transparency" |
*
* @param {Vc_Status_Works_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_works_2 = /** @type {((inputs?: Vc_Status_Works_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Works_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_works_2(inputs)
	return zh_vc_status_works_2(inputs)
});
export { vc_status_works_2 as "vc.status.works.2" }